import SaleBookTableRowView from './SaleBookTableRow'
import withSaleBookTableRow from './withSaleBookTableRow'

const SaleBookTableRow = withSaleBookTableRow(SaleBookTableRowView)

export default SaleBookTableRow
